import CaravanSVG from "../Icons/CaravanSVG";
import CarSVG from "../Icons/CarSVG";
import MotorbikeSVG from "../Icons/MotorbikeSVG";
import MotorhomeSVG from "../Icons/MotorhomeSVG";
import { VehicleType } from "../../types/vehicleTypes";

const VehicleTypeSvgMapper = {
  [VehicleType.CAR]: <CarSVG />,
  [VehicleType.CARAVAN]: <CaravanSVG />,
  [VehicleType.MOTORCYCLE]: <MotorbikeSVG />,
  [VehicleType.MOTORHOME]: <MotorhomeSVG />,
};

export default VehicleTypeSvgMapper;
